module.exports = __webpack_public_path__ + "media/images/og-70aa02b1ff9dd5cd39763dfadc10350f.png";